import React, { useState } from 'react';
import './Navbar.css';
import { NavLink } from 'react-router-dom';
import ServicesMegaMenu from '../../MegaMenu/ServicesMegaMenu';
import GalleryMegaMenu from '../../MegaMenu/GalleryMegaMenu';
import AboutUsMegaMenu from '../../MegaMenu/AboutUsMegaMenu';
import CareerMegaMenu from '../../MegaMenu/CareerMegaMenu';
import ContactUsMenu from '../../MegaMenu/ContactUsMenu';
import LoginMenu from '../../MegaMenu/LoginMenu';
import MenuIcon from '@mui/icons-material/Menu';
import RightSideMenu from '../RightSideMenu/RightSideMenu';




const Navbar = () => {
    const [servicesStatus,setServicesStatus]=useState(false);
    const [galleryStatus,setGalleryStatus]=useState(false);
    const [aboutusStatus,setAboutusStatus]=useState(false);
    const [careerStatus,setCareerStatus]=useState(false);
    const [contactusStatus,setContactusStatus]=useState(false)
    const [loginStatus,setLoginStatus]=useState(false);
    const [rightSideMenuStatus,setRightSideMenuStatus]=useState(false);
  return (
   <>
    <div className="container-fluid" id='navbar'>
        <div className="row">
            <NavLink to='/' className="col col-2 left-col"><img src="img-data/logo.png" alt="logo" /></NavLink>
            <div className="col col-6 middle-col d-md-block d-none">
                <div className="row">
                    <NavLink to='/' className="col">Home</NavLink>
                    <NavLink to="/about-us" className="col" onMouseOver={()=>setAboutusStatus(true)} onMouseOut={()=>setAboutusStatus(false)} onClick={()=>setAboutusStatus(!aboutusStatus)}>About Us
                    {aboutusStatus && <AboutUsMegaMenu/>}
                    </NavLink>
                    <NavLink to='/services' className="col" onMouseOver={()=>setServicesStatus(true)} onMouseOut={()=>setServicesStatus(false)} onClick={()=>setServicesStatus(!servicesStatus)}>Services
                    {servicesStatus && <ServicesMegaMenu/> }</NavLink>
                    {/* <NavLink to='/services' className="col">Our Products
                    </NavLink> */}
                    <NavLink to='/gallery' className="col " onMouseOver={()=>setGalleryStatus(true)} onMouseOut={()=>setGalleryStatus(false)} onClick={()=>setGalleryStatus(!galleryStatus)}>Gallery
                    {galleryStatus && <GalleryMegaMenu/>}</NavLink>
                    
                    <NavLink to="/career" className="col" onMouseOver={()=>setCareerStatus(true)} onMouseOut={()=>setCareerStatus(false)} onClick={()=>setCareerStatus(!careerStatus)}>Career
                    {careerStatus && <CareerMegaMenu/>}
                    </NavLink>
                </div>
            </div>
            <div className="col col-2 right-col ">
                <div className="row">
                    <div className="col d-lg-none d-block" 
                    onClick={()=>setRightSideMenuStatus(!rightSideMenuStatus)}>
                    <MenuIcon/>
                    {rightSideMenuStatus && <RightSideMenu/>}
                    </div>
                    <NavLink to="/contact-us" className="col d-none d-lg-block" onMouseOver={()=>setContactusStatus(true)} onMouseOut={()=>setContactusStatus(false)}>Contact Us
                    {contactusStatus && <ContactUsMenu/>}</NavLink>
                    {/* <NavLink  className="col d-none d-lg-block " onMouseOver={()=>setLoginStatus(true)} onMouseOut={()=>setLoginStatus(false)}>Projects
                    {loginStatus && <LoginMenu/>}</NavLink> */}
                    <NavLink to='/projects' className="col d-none d-lg-block " onMouseOver={()=>setLoginStatus(true)} onMouseOut={()=>setLoginStatus(false)}>Projects
                    </NavLink>
                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default Navbar
